export const getAddMealModalSteps = (t) => [
    {
        target: '[data-tour="aml-modal"]',
        placement: 'center',
        title: t('tour.addMealModal.step-welcome-title'),
        content: t('tour.addMealModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="aml-meal-select"]',
        title: t('tour.addMealModal.step-meal-title'),
        content: t('tour.addMealModal.step-meal-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="aml-food-table"]',
        title: t('tour.addMealModal.step-table-title'),
        content: t('tour.addMealModal.step-table-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="aml-actions"]',
        title: t('tour.addMealModal.step-actions-title'),
        content: t('tour.addMealModal.step-actions-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="aml-footer"]',
        title: t('tour.addMealModal.step-footer-title'),
        content: t('tour.addMealModal.step-footer-content'),
        disableBeacon: true,
    },
];
